export default __webpack_public_path__ + "static/media/checkbox-spacing.b8366acd.svg";